import React from 'react';
import { Hero } from './Hero';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { UniqueMechanism } from './UniqueMechanism';
import { Contents } from './Contents';
import { SevenDayPlan } from './SevenDayPlan';
import { Bonuses } from './Bonuses';
import { Objections } from './Objections';
import { SocialProof } from './SocialProof';
import { Pricing } from './Pricing';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
export function OriginalLander() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-brand-pink selection:text-brand-dark pt-[72px]" data-id="element-258">
      <Hero data-id="element-259" />
      <Problem data-id="element-260" />
      <Solution data-id="element-261" />
      <UniqueMechanism data-id="element-262" />
      <Contents data-id="element-263" />
      <SevenDayPlan data-id="element-264" />
      <Bonuses data-id="element-265" />
      <Objections data-id="element-266" />
      <SocialProof data-id="element-267" />
      <Pricing data-id="element-268" />
      <FAQ data-id="element-269" />

      {/* Final Close Section */}
      <section className="bg-brand-dark text-white py-20 px-4 text-center" data-id="element-270">
        <div className="max-w-2xl mx-auto" data-id="element-271">
          <h2 className="text-3xl font-bold mb-6" data-id="element-272">
            Tu primera venta no te cambia solo el bolsillo… <br data-id="element-273" />
            <span className="text-brand-pink" data-id="element-274">te cambia la cabeza.</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-275">
            Porque después de esa primera venta, ya no eres "una mamá que
            quiere". Eres una mamá que{' '}
            <span className="font-bold text-white" data-id="element-276">puede</span>.
          </p>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-brand-pink hover:bg-rose-400 text-brand-dark font-bold py-4 px-8 rounded-full text-xl transition-all transform hover:-translate-y-1" data-id="element-277">
            Descargar Mamá Digital 2.0 ahora
          </button>
        </div>
      </section>

      <Footer data-id="element-278" />
    </div>;
}